import { PRICE_SET_MIN, PRICE_SET_MAX } from 'components/OneColumnSearchResultPage/constants'
import isEmpty from 'lodash/isEmpty'

export const createRequestPayloadForInventoryService = (
  frontQuantity,
  rearQuantity,
  brand,
  ntwBufferDays,
  frontTireBvId,
  rearTireBvId,
  requestedStore
) => {
  // These 2 are the static values that will be useful for future
  // but for now they don't need any dynamic values but required to be send with the reqPayload
  const commonStaticValues = {
    requestedDateTime: '06-30-2023 18:08:20',
    requestedTimeZone: 'America/Chicago'
  }

  if (frontTireBvId && rearTireBvId) {
    return {
      partNumbers: [
        {
          partNumber: frontTireBvId,
          quantity: frontQuantity,
          brand: brand.toUpperCase()
        },
        {
          partNumber: rearTireBvId,
          quantity: rearQuantity,
          brand: brand.toUpperCase()
        }
      ],
      requestedStore,
      delayInDaysNTWAvailability: ntwBufferDays,
      ...commonStaticValues
    }
  }

  return {
    partNumbers: [
      {
        partNumber: frontTireBvId || rearTireBvId,
        quantity: frontQuantity || rearQuantity,
        brand: brand.toUpperCase()
      }
    ],
    requestedStore,
    delayInDaysNTWAvailability: ntwBufferDays,
    ...commonStaticValues
  }
}

export const prepareUniqueProductList = ({
  visibleRecords = [],
  GBBDetails = []
}) => {
  // We are using quantity default value due to we are using this payload only to call inventory
  // for products that just appear on the Search Result Page
  const defaultQuantityValue = PRICE_SET_MAX
  const defaultQuantityValueForStaggeredFitment = PRICE_SET_MIN

  // Product list on the SERP can contain GBB products. Thats why we need to create a unique
  // product list taking into account that products (records) in the TireResultList component
  // and GBB products in the BOTRecommendedSearchResult component have a different attributes
  // structure

  const uniqueProductsList = [...visibleRecords, ...GBBDetails].reduce((acc, curr) => {
    if (curr.attributes) {
      const { attributes: {
        bvId: [bvId] = [],
        brandName: [brandName] = [],
        rearTire,
        frontTire
      }} = curr

      if (!isEmpty(rearTire)) {
        if (acc.some(item => item.partNumber === bvId) || acc.some(item => item.partNumber === rearTire[0].bvId)) {
          return [...acc]
        }

        if (acc.some(item => item.partNumber === bvId) || !acc.some(item => item.partNumber === rearTire[0].bvId)) {
          return [...acc, {
            brand: brandName.toUpperCase(),
            partNumber: rearTire[0].bvId,
            quantity: defaultQuantityValueForStaggeredFitment,
            skuId: rearTire[0].rearTireSkuId,
            staggeredSku: curr.attributes.staggeredSkuId[0]
          }]
        }

        if (!acc.some(item => item.partNumber === bvId) || acc.some(item => item.partNumber === rearTire[0].bvId)) {
          return [...acc, {
            brand: brandName.toUpperCase(),
            partNumber: bvId,
            quantity: defaultQuantityValueForStaggeredFitment,
            skuId: frontTire[0].frontTireSkuId,
            staggeredSku: curr.attributes.staggeredSkuId[0]
          }]
        }

        return [...acc, {
          brand: brandName.toUpperCase(),
          partNumber: bvId,
          quantity: defaultQuantityValueForStaggeredFitment,
          skuId: frontTire[0].frontTireSkuId,
          staggeredSku: curr.attributes.staggeredSkuId[0]
        },
        {
          brand: brandName.toUpperCase(),
          partNumber: rearTire[0].bvId,
          quantity: defaultQuantityValueForStaggeredFitment,
          skuId: rearTire[0].rearTireSkuId,
          staggeredSku: curr.attributes.staggeredSkuId[0]
        }]
      }

      if (acc.some(item => item.partNumber === bvId)) {
        return [...acc]
      }

      return [...acc, {
        brand: brandName.toUpperCase(),
        partNumber: bvId,
        quantity: defaultQuantityValue,
        skuId: frontTire[0].frontTireSkuId
      }]
    }

    if (acc.some(item => item.partNumber === curr.bvId)) {
      return [...acc]
    }

    return [...acc, {
      brand: curr.brandName.toUpperCase(),
      partNumber: curr.bvId,
      quantity: defaultQuantityValue,
      skuId: curr.skuId
    }]
  }, [])

  return uniqueProductsList
}

export const createProductSKUIdList = (products) => products.map(item => item.staggeredSku || item.skuId)

export const createInventoryPayloadForProductList = ({
  productList,
  storeNumber,
  ntwBufferDays
}) => {
  // These 2 are the static values that will be useful for future
  // but for now they don't need any dynamic values but required to be send with the reqPayload
  const commonStaticValues = {
    requestedDateTime: '06-30-2023 18:08:20',
    requestedTimeZone: 'America/Chicago'
  }

  const productsWithoutSKUId = productList.map(({
    brand,
    partNumber,
    quantity
  }) => ({
    brand,
    partNumber,
    quantity
  }))

  return {
    partNumbers: productsWithoutSKUId,
    requestedStore: storeNumber,
    delayInDaysNTWAvailability: ntwBufferDays,
    ...commonStaticValues
  }
}
